/* ==========================================================================
   Zapatos Obi — theme.js
   Núcleo del tema: pub/sub de eventos y utilidades compartidas.
   Los módulos (cart, búsqueda, producto) lo consumen vía window.Obi.
   ========================================================================== */
(function () {
  'use strict';

  window.Obi = window.Obi || {};

  /* ---------- Rutas de Shopify (con prefijo de idioma/mercado) ---------- */
  Obi.routes = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- Nombres de eventos ---------- */
  Obi.events = {
    cartUpdated: 'cart:updated',
    cartError: 'cart:error',
    drawerOpen: 'drawer:open',
    drawerClose: 'drawer:close',
  };

  /* ---------- Pub/Sub ---------- */
  var subscribers = {};

  Obi.on = function (event, callback) {
    (subscribers[event] = subscribers[event] || []).push(callback);
    return function () {
      Obi.off(event, callback);
    };
  };

  Obi.off = function (event, callback) {
    if (!subscribers[event]) return;
    subscribers[event] = subscribers[event].filter(function (cb) {
      return cb !== callback;
    });
  };

  Obi.emit = function (event, detail) {
    (subscribers[event] || []).forEach(function (cb) {
      cb(detail);
    });
  };

  /* ---------- Helpers fetch ---------- */
  Obi.fetchJSON = function (url, options) {
    options = options || {};
    var headers = Object.assign(
      { 'Content-Type': 'application/json', Accept: 'application/json' },
      options.headers || {}
    );
    return fetch(url, Object.assign({}, options, { headers: headers })).then(function (res) {
      return res.json();
    });
  };

  /* Obtiene el HTML de una o varias secciones vía Section Rendering API. */
  Obi.getSectionHTML = function (sectionId, params) {
    var url = Obi.routes + '?section_id=' + encodeURIComponent(sectionId);
    if (params) url += '&' + params;
    return fetch(url).then(function (res) {
      return res.text();
    });
  };

  /* El carrusel de fotos de la tarjeta se retiró el 17-09-2026: una sola foto por tarjeta. */

  /* ---------- Utilidad: debounce ---------- */
  Obi.debounce = function (fn, wait) {
    var t;
    return function () {
      var args = arguments;
      var ctx = this;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait || 250);
    };
  };
})();
